import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { useTranslation } from "react-i18next";
import { getOrgBackend } from "../../../app/backend";

interface RequestBody {
  userId: string;
  ids?: string[];
  supervisorTransitionEmails?: string[];
}

export function useRemoteDeleteSupervisorRights() {
  const { t } = useTranslation();
  return useRemoteMutation<void, RemoteApiError, RequestBody>({
    key: "deleteTransferSupervisorRights",
    url: `${getOrgBackend()}/supervisor-transition-rights/delete`,
    snackbarTextOnSuccess: t("_supervisorTransferDeleteSuccess"),
    snackbarTextOnFail: t("_supervisorTransferDeleteError")
  });
}
